module.exports = __webpack_public_path__ + "img/logos_customer_17.0083f6ab.svg";